import { createContext } from 'react';
var countryListDetails = {
  countryList: [{
    countryCode: '',
    countryId: '',
    countryName: '',
    isdCode: '',
    region: ''
  }]
};
var defaultState = {
  countryData: countryListDetails.countryList
};
var CountryListDetailsContext = /*#__PURE__*/createContext(defaultState);
export { CountryListDetailsContext, countryListDetails };